var _g, _circle, _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccepted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_375:40181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.275 65.5C1.46627 65.5 -0.00854156 66.9674 0.0818456 68.7738C0.67254 80.5794 4.44912 92.0278 11.0387 101.89C18.236 112.661 28.4657 121.057 40.4342 126.014C52.4028 130.972 65.5727 132.269 78.2784 129.741C90.9842 127.214 102.655 120.976 111.815 111.815C120.976 102.655 127.214 90.9842 129.741 78.2784C132.269 65.5727 130.972 52.4028 126.014 40.4342C121.057 28.4657 112.661 18.236 101.89 11.0387C92.0278 4.44912 80.5794 0.672539 68.7738 0.0818454C66.9674 -0.00854165 65.5 1.46627 65.5 3.275V3.275C65.5 5.08373 66.9674 6.54051 68.7734 6.64093C79.2827 7.2253 89.4661 10.6151 98.2509 16.4849C107.945 22.9624 115.501 32.1691 119.963 42.9408C124.424 53.7125 125.592 65.5654 123.317 77.0006C121.043 88.4358 115.428 98.9396 107.184 107.184C98.9396 115.428 88.4358 121.043 77.0006 123.317C65.5654 125.592 53.7125 124.424 42.9408 119.963C32.1691 115.501 22.9624 107.945 16.4849 98.2509C10.6151 89.4661 7.2253 79.2827 6.64093 68.7734C6.54051 66.9674 5.08373 65.5 3.275 65.5V65.5Z",
    fill: "#C7CBD1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65.5,
    r: 65.5,
    fill: "#28A745"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_375:40181",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 41.6667V43.3333H83.375H81.75V45V46.6667H80.125H78.5V48.3333V50H76.875H75.25V51.6667V53.3333H73.625H72V55V56.6667H70.375H68.75V58.3333V60H67.125H65.5V61.6667V63.3333H63.875H62.25V65V66.6667H60.625H59V68.3333V70H57.375H55.75V71.6667V73.3333H54.125H52.5V71.6667V70H50.875H49.25V68.3333V66.6667H47.625H46V65V63.3333H39.5H33V70V76.6667H34.625H36.25V78.3333V80H37.875H39.5V81.6667V83.3333H41.125H42.75V85V86.6667H44.375H46V88.3333V90H54.125H62.25V88.3333V86.6667H63.875H65.5V85V83.3333H67.125H68.75V81.6667V80H70.375H72V78.3333V76.6667H73.625H75.25V75V73.3333H76.875H78.5V71.6667V70H80.125H81.75V68.3333V66.6667H83.375H85V65V63.3333H86.625H88.25V61.6667V60H89.875H91.5V58.3333V56.6667H93.125H94.75V55V53.3333H96.375H98V46.6667V40H91.5H85V41.6667Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 41.6667V43.3333H83.375H81.75V45V46.6667H80.125H78.5V48.3333V50H76.875H75.25V51.6667V53.3333H73.625H72V55V56.6667H70.375H68.75V58.3333V60H67.125H65.5V61.6667V63.3333H63.875H62.25V65V66.6667H60.625H59V68.3333V70H57.375H55.75V71.6667V73.3333H54.125H52.5V71.6667V70H50.875H49.25V68.3333V66.6667H47.625H46V65V63.3333H39.5H33V70V76.6667H34.625H36.25V78.3333V80H37.875H39.5V81.6667V83.3333H41.125H42.75V85V86.6667H44.375H46V88.3333V90H54.125H62.25V88.3333V86.6667H63.875H65.5V85V83.3333H67.125H68.75V81.6667V80H70.375H72V78.3333V76.6667H73.625H75.25V75V73.3333H76.875H78.5V71.6667V70H80.125H81.75V68.3333V66.6667H83.375H85V65V63.3333H86.625H88.25V61.6667V60H89.875H91.5V58.3333V56.6667H93.125H94.75V55V53.3333H96.375H98V46.6667V40H91.5H85V41.6667Z",
    fill: "#FAFAFA",
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-3-inside-1_375:40181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_375:40181",
    x: 0.078125,
    y: 0.0778809,
    width: 130.922,
    height: 134.922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_375:40181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.901f69431334f47cff58341f699afcab.svg";
export { ForwardRef as ReactComponent };